import React, { useMemo, useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Table,
  Typography,
  Tabs,
  TabPane,
  Form,
  Button,
  Divider,
} from "@douyinfe/semi-ui";
import { VChart } from "@visactor/react-vchart";
import {
  IconStackBarChartStroked,
  IconPieChartStroked,
  IconSearch,
  IconUndo,
} from "@douyinfe/semi-icons";
import { ApiClient } from "../../api/ApiClient";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { generateMockData } from "./testData";

export default function TrendDashboard() {
  const [city, setCity] = useState(undefined as undefined | string);
  const [createdAt, setCreatedAt] = useState(undefined as undefined | string);
  const [filterFormApi, setFilterFormApi] = useState<FormApi>();
  const [statData, setStatData] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [dateNewLeadAmount, setDateNewLeadAmount] = useState([] as any);
  const [loadingDateNewLeadAmount, setLoadingDateNewLeadAmount] =
    useState(false);
  const [dateNewLeadStarRatio, setDateNewLeadStarRatio] = useState([] as any);
  const [loadingDateNewLeadStarRatio, setLoadingDateNewLeadStarRatio] =
    useState(false);
  const [dateAssingnContact, setDateAssingnContact] = useState([] as any);
  const [loadingDateAssingnContact, setLoadingDateAssingnContact] =
    useState(false);
  const [dateLeadVisitStar, setDateLeadVisitStar] = useState([] as any);
  const [loadingDateLeadVisitStar, setLoadingDateLeadVisitStar] =
    useState(false);
  const [dateSaleKpiTop, setDateSaleKpiTop] = useState([] as any);
  const [loadingDateSaleKpiTop, setLoadingDateSaleKpiTop] = useState(false);
  const [dateSaleVisitKpiTop, setDateSaleVisitKpiTop] = useState([] as any);
  const [loadingDateSaleVisitKpiTop, setLoadingDateSaleVisitKpiTop] =
    useState(false);
  const [citys, setCitys] = useState([] as any);

  let apiClient = ApiClient.getDefault();

  const { Title, Text } = Typography;
  useEffect(() => {
    apiClient.getDictAsOpts("city").then((resp) => {
      setCitys(resp);
    });
    queryAll();
  }, []);

  const queryAll = async () => {
    let data = getQueryParams();
    queryDateNewLeadAmount(data);
    queryDateNewLeadStarRatio(data);
    queryDateAssingnContact(data);
    queryDateLeadVisitStar(data);
    queryDateSaleKpiTop(data);
    queryDateSaleVisitKpiTop(data);
  };
  const getQueryParams = () => {
    let data = {
      city: filterFormApi?.getValue("city"),
      createdAt: filterFormApi?.getValue("createdAt"),
    };
    return data;
  };
  const queryDateNewLeadAmount = async (data: any) => {
    setLoadingDateNewLeadAmount(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData(1);
    setDateNewLeadAmount(dt);
    setLoadingDateNewLeadAmount(false);
  };

  const queryDateNewLeadStarRatio = async (data: any) => {
    setLoadingDateNewLeadStarRatio(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData(2);
    setDateNewLeadStarRatio(dt);
    setLoadingDateNewLeadStarRatio(false);
  };

  const queryDateAssingnContact = async (data: any) => {
    setLoadingDateAssingnContact(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData(3);
    setLoadingDateAssingnContact(false);
    setDateAssingnContact(dt);
  };

  const queryDateLeadVisitStar = async (data: any) => {
    setLoadingDateLeadVisitStar(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    // setDateLeadVisitStar(data);
    // setLoadingDateLeadVisitStar(false);
    //   });

    const dt = generateMockData(4);
    setDateLeadVisitStar(dt);
    setLoadingDateLeadVisitStar(false);
  };

  const queryDateSaleKpiTop = async (data: any) => {
    setLoadingDateSaleKpiTop(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData(5);
    setDateSaleKpiTop(dt);
    setLoadingDateSaleKpiTop(false);
  };

  const queryDateSaleVisitKpiTop = async (data: any) => {
    setLoadingDateSaleVisitKpiTop(true);
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData(5);
    setDateSaleVisitKpiTop(dt);
    setLoadingDateSaleVisitKpiTop(false);
  };

  const dateNewLeadAmountSpec: any = {
    type: "area",
    stack: true,
    xField: "type",
    yField: "value",
    seriesField: "seriesValue",
    data: {
      fields: {
        seriesValue: {
          domain: ["5万及以下", "5万-20万", "20万+"],
          lockStatisticsByDomain: true,
        },
      },
      values: dateNewLeadAmount.chartData,
    },
    legends: { visible: true },
    tooltip: {
      dimension: {
        updateContent: (data: any[]) => {
          let sum = 0;
          data.forEach((datum) => {
            sum += +datum.value;
          });
          data.push({
            hasShape: "false",
            key: "总数",
            value: sum,
          });
          return data;
        },
      },
    },
  };

  const dateNewLeadStarRatioSpec: any = {
    type: "bar",
    percent: true,
    stack: true,
    data: {
      id: "barRatio",
      values: dateNewLeadStarRatio.chartData,
    },
    xField: "type",
    yField: "value",
    seriesField: "seriesValue",
    legends: { visible: true },
    direction: "vertical",
    axes: [
      {
        orient: "left",
        label: {
          formatMethod: (val: number) => {
            return `${(val * 100).toFixed(2)}%`;
          },
        },
      },
    ],
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const dateAssingnContactSpec = {
    type: "line",
    xField: "type",
    yField: "value",
    seriesField: "seriesValue",
    legends: { visible: true },
    data: { values: dateAssingnContact.chartData },
    label: {
      visible: true,
      position: "top",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const dateLeadVisitStarSpec: any = {
    type: "bar",
    stack: true,
    data: {
      id: "barData",
      values: dateLeadVisitStar.chartData,
    },
    xField: "type",
    yField: "value",
    seriesField: "seriesValue",
    legends: { visible: true },
    tooltip: {
      dimension: {
        updateContent: (data: any[]) => {
          let sum = 0;
          data.forEach((datum) => {
            sum += +datum.value;
          });
          data.push({
            hasShape: "false",
            key: "总数",
            value: sum,
          });
          return data;
        },
      },
    },
    direction: "vertical",
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const colorScheme = {
    /** 默认渐进式色板 */
    default: [
      {
        maxDomainLength: 1,
        scheme: ["rgba(142, 212, 231, 1)"], // 适用于 1 个数据项的色板
      },
    ],
  };
  const dateSaleKpiTopSpec = {
    type: "bar",
    data: [
      {
        id: "barKpi",
        values: dateSaleKpiTop.chartData,
      },
    ],
    seriesField: "seriesValue",
    xField: "type",
    yField: "value",
    direction: "vertical",
    legends: {
      visible: true,
    },
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const dateSaleVisitKpiTopSpec = {
    type: "bar",
    data: [
      {
        id: "barVisitKpi",
        values: dateSaleVisitKpiTop.chartData,
      },
    ],
    theme: { colorScheme },
    seriesField: "seriesValue",
    xField: "type",
    yField: "value",
    direction: "vertical",
    legends: {
      visible: true,
    },
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  let handleFilterSubmit = async () => {
    await filterFormApi!.validate();
    queryAll();
  };
  let handleFilterReset = () => {
    filterFormApi?.reset();
  };

  return (
    <>
      <div className="crud-filter-form">
        <Form layout="horizontal" getFormApi={(api) => setFilterFormApi(api)}>
          <Form.Select
            showClear
            filter={true}
            rules={[{ required: true, message: "城市不能为空" }]}
            key="city"
            initValue={city}
            multiple={false}
            style={{ width: "100%", minWidth: 150 }}
            label="城市"
            field="city"
            optionList={citys.map((o: any) => {
              return {
                label: o.label,
                value: o.value,
                disabled: o.disabled,
              };
            })}
          />
          <Form.DatePicker
            rules={[{ required: true, message: "日期不能为空" }]}
            key="createdAt"
            type="dateRange"
            label="日期"
            initValue={createdAt}
            field="createdAt"
          />

          <Form.Slot label={"⠀"}>
            <Button
              icon={<IconSearch />}
              theme="solid"
              onClick={handleFilterSubmit}
              loading={loading}
              htmlType="submit"
            >
              筛选
            </Button>
          </Form.Slot>
          <Form.Slot label={"⠀"}>
            <Button
              icon={<IconUndo />}
              type="warning"
              theme="solid"
              onClick={handleFilterReset}
              loading={loading}
              htmlType="reset"
            >
              重置
            </Button>
          </Form.Slot>
        </Form>
        <Divider margin="5px" />
      </div>

      <div
        style={{ padding: 20, backgroundColor: "#f8f9fa", minHeight: "100vh" }}
      >
        {/* 顶部卡片 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">累计新增客户</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">平均跟进率</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.avgFollowRate}
              </Title>
              <Text type="secondary">行业基准 65%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">0星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">1-2星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">3+星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">总上门量</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={3}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">总签约量</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
        </Row>

        {/* 第一行：新增客户和星级分布 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card
              title="新客趋势"
              headerExtraContent={
                <Text type="secondary">
                  每日新增客户趋势，不同申请额度的数量
                </Text>
              }
            >
              <VChart
                spec={dateNewLeadAmountSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />
              <Table
                loading={loadingDateNewLeadAmount}
                columns={[
                  { title: "日期", dataIndex: "type" },
                  {
                    title: "新增客户",
                    dataIndex: "valueTotal",
                    sorter: (a, b) =>
                      (a?.valueTotal || 0) - (b?.valueTotal || 0),
                  },
                  { title: "5万及以下", dataIndex: "value" },
                  { title: "5万-20万", dataIndex: "value1" },
                  { title: "20万+", dataIndex: "value2" },
                ]}
                dataSource={dateNewLeadAmount.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>

          <Col span={12}>
            <Card
              title="新客质量"
              headerExtraContent={
                <Text type="secondary">每日新增客户星级比例</Text>
              }
            >
              <VChart
                spec={dateNewLeadStarRatioSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

              <Table
                loading={loadingDateNewLeadStarRatio}
                columns={[
                  { title: "日期", dataIndex: "type" },
                  { title: "数量", dataIndex: "valueTotal" },
                  { title: "0星占比", dataIndex: "value" },
                  { title: "1星占比", dataIndex: "value1" },
                  { title: "2星占比", dataIndex: "value1" },
                  { title: "3+星占比", dataIndex: "value1" },
                ]}
                dataSource={dateNewLeadStarRatio.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>
        </Row>

        {/* 第二行：客户跟进和上门分析 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card
              title="再分配客户跟进分析"
              headerExtraContent={
                <Text type="secondary">每日再分配客户跟进情况，跟进率</Text>
              }
            >
              <VChart
                spec={dateAssingnContactSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

              <Table
                loading={loadingDateAssingnContact}
                columns={[
                  { title: "日期", dataIndex: "type" },
                  { title: "分配数", dataIndex: "valueTotal" },
                  { title: "已跟进", dataIndex: "value" },
                  {
                    title: "跟进率",
                    render: (_, record) =>
                      `${((record.value / record.valueTotal) * 100).toFixed(
                        1
                      )}%`,
                  },
                ]}
                dataSource={dateAssingnContact.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>

          <Col span={12}>
            <Card
              title="客户上门分析"
              headerExtraContent={
                <Text type="secondary">每日上门 客户数，上门客户星级分布</Text>
              }
            >
              <VChart
                spec={dateLeadVisitStarSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

              <Table
                loading={loadingDateLeadVisitStar}
                columns={[
                  { title: "日期", dataIndex: "type" },
                  { title: "总上门数", dataIndex: "valueTotal" },
                  { title: "0星客户", dataIndex: "value1" },
                  { title: "1星客户", dataIndex: "value1" },
                  { title: "2星客户", dataIndex: "value2" },
                  { title: "3星+客户", dataIndex: "value3" },
                ]}
                dataSource={dateLeadVisitStar.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>
        </Row>

        {/* 销售排行榜 */}

        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card
              title="销售新客TOP10"
              headerExtraContent={
                <Text type="secondary">按新客分配数来对销售进行排名</Text>
              }
            >
              <VChart
                key="sales-kpi"
                spec={dateSaleKpiTopSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />
              <Table
                loading={loadingDateSaleKpiTop}
                columns={[
                  { title: "排名", render: (_, __, index) => index + 1 },
                  { title: "销售姓名", dataIndex: "type" },
                  { title: "新客数", dataIndex: "value1" },
                ]}
                dataSource={dateSaleKpiTop.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>
          <Col span={12}>
            <Card
              title="销售上门TOP10"
              headerExtraContent={
                <Text type="secondary">按客户上门数来对销售进行排名</Text>
              }
            >
              <VChart
                key="sales-kpi"
                spec={dateSaleVisitKpiTopSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />
              <Table
                loading={loadingDateSaleVisitKpiTop}
                columns={[
                  { title: "排名", render: (_, __, index) => index + 1 },
                  { title: "销售姓名", dataIndex: "type" },
                  { title: "上门数", dataIndex: "value" },
                ]}
                dataSource={dateSaleVisitKpiTop.tableData}
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
